import React from 'react'

// eslint-disable-next-line react/prop-types
const PrazoEntrega = ( { previsaoEntrega } ) => {
  return previsaoEntrega && (
    <div className="prazo-entrega">
      <span className="bold-text"> Prazo de entrega: </span>

      <span className="normal-text"> {previsaoEntrega} </span>
    </div> )
}

export default PrazoEntrega
